import axios from "axios";
import { config } from "../config";
import Cookies from "js-cookie";

export const Api = axios.create({
  baseURL: `${config.REACT_APP_BACKEND_URL}`,
  withCredentials: true,
});

Api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
